import { useI18n, LANGS } from "@/i18n";
import { api } from "@/lib/api";
import { Languages } from "lucide-react";

export function LanguageToggle({ dark = false }) {
  const { lang, setLang } = useI18n();
  const pick = (code) => {
    setLang(code);
    if (localStorage.getItem("ct_token")) {
      api.put("/auth/language", { language: code }).catch(() => {});
    }
  };
  return (
    <div className={`inline-flex items-center rounded-full border ${dark ? "border-white/20" : "border-slate-200"} overflow-hidden text-xs font-bold`} data-testid="language-toggle">
      <Languages size={13} className={`ml-2 mr-1 ${dark ? "text-slate-300" : "text-slate-400"}`} />
      {LANGS.map(([code, label]) => (
        <button key={code} onClick={() => pick(code)} data-testid={`lang-${code}`}
          className={`px-2 py-1 transition-colors ${lang === code ? "bg-brand text-white" : dark ? "text-slate-300 hover:bg-white/10" : "text-slate-500 hover:bg-slate-100"}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
